import { render, staticRenderFns } from "./OdontogramaAtualizarAtendimento.vue?vue&type=template&id=473ff324&scoped=true"
import script from "./OdontogramaAtualizarAtendimento.vue?vue&type=script&lang=js"
export * from "./OdontogramaAtualizarAtendimento.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaAtualizarAtendimento.vue?vue&type=style&index=0&id=473ff324&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ff324",
  null
  
)

export default component.exports